import React from 'react';
import { View, Text } from 'react-native';
import { useThemedStyles } from '../theme/useThemedStyles';
import type { Theme } from '../theme/types';

interface AiUnavailableBannerProps {
  reason: string;
}

export default function AiUnavailableBanner({ reason }: AiUnavailableBannerProps) {
  const styles = useThemedStyles(createStyles);

  return (
    <View style={styles.container} accessibilityRole="alert" accessibilityLabel={reason} testID="ai-unavailable-banner">
      <Text style={styles.icon} accessible={false}>{'\u{2139}\uFE0F'}</Text>
      <Text style={styles.text} accessible={false}>{reason}</Text>
    </View>
  );
}

const createStyles = (theme: Theme) => ({
  container: {
    flexDirection: 'row' as const,
    alignItems: 'flex-start' as const,
    backgroundColor: theme.colors.info,
    borderWidth: 1,
    borderColor: theme.colors.infoBorder,
    borderRadius: 10,
    padding: 12,
    marginTop: 10,
    gap: 8,
  },
  icon: {
    fontSize: 16,
    marginTop: 1,
  },
  text: {
    fontSize: 13,
    color: theme.colors.infoText,
    lineHeight: 18,
    flex: 1,
  },
});
